// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".filter-popup__close-icon{border-radius:50%;border:1px solid #202124}.filter-popup__filter-items{max-height:400px;overflow-y:auto;-ms-overflow-style:none;scrollbar-width:none}.filter-popup__filter-items::-webkit-scrollbar{display:none}.filter-popup__button{border-radius:20px;border-color:#19a0dd}.filter-popup__button-container{justify-content:center}.filter-popup__item-disabled{opacity:.5}", ""]);
// Exports
module.exports = exports;
